import React, { createContext, useContext, useState } from 'react';
import { DateFilter } from '../types/filterTypes';

// Define the context type
interface FilterContextType {
  dateFilter: DateFilter | null;
  setDateFilter: (filter: DateFilter | null) => void;
}

// Create the context with an undefined initial value to enforce the provider usage
const FilterContext = createContext<FilterContextType | undefined>(undefined);

// Create the provider component
export const FilterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [dateFilter, setDateFilter] = useState<DateFilter | null>(null);

  return (
    <FilterContext.Provider value={{ dateFilter, setDateFilter }}>
      {children}
    </FilterContext.Provider>
  );
};

// Custom hook to use the filter context
export const useFilter = () => {
  const context = useContext(FilterContext);

  if (context === undefined) {
    throw new Error('useFilter must be used within a FilterProvider');
  }

  return context;
};
